import { createFileRoute } from '@tanstack/react-router';

import { DevicesListView } from '../../../features/devices/devices-list-view';

export const Route = createFileRoute('/admin/devices/')({
  component: DevicesListView,
});
